import dayjs from 'dayjs';
import {
  ASSIGNMENT_STATUS,
  WEEKLY_PROGRESS_MESSAGES,
} from '../../utils/constants';

export const sortWeeklyAssignmentsByStatus = (assignments) => {
  const assignmentStatusSortOrder = {
    [ASSIGNMENT_STATUS.COMPLETED]: 1,
    [ASSIGNMENT_STATUS.IN_PROGRESS]: 2,
    [ASSIGNMENT_STATUS.MISSED]: 3,
    [ASSIGNMENT_STATUS.NOT_STARTED]: 4,
  };

  const sortedCurrentWeekAssignments = [...assignments].sort((a, b) => {
    const aStatus = assignmentStatusSortOrder[a.status];
    const bStatus = assignmentStatusSortOrder[b.status];
    if (aStatus === bStatus) {
      return (
        new Date(a.studentAssignmentDueAt) - new Date(b.studentAssignmentDueAt)
      );
    }
    return aStatus - bStatus;
  });
  return sortedCurrentWeekAssignments;
};

export const getNextAssignmentDueString = (assignments) => {
  const currentTime = new Date();
  // Pre-process assignments to create Date objects once and filter future assignments
  const futureAssignments = assignments
    .map((assignment) => ({
      ...assignment,
      dueDateObject: new Date(assignment.studentAssignmentDueAt),
    }))
    .filter((assignment) => assignment.dueDateObject > currentTime)
    .sort((a, b) => a.dueDateObject - b.dueDateObject);

  if (futureAssignments.length === 0) {
    return 'There are no future assignments due';
  }

  const nextAssignmentDue = futureAssignments[0];
  const daysUntilDue = dayjs(nextAssignmentDue.dueDateObject).diff(
    dayjs(),
    'days',
  );

  let daysUntilDueString;
  if (daysUntilDue === 0) {
    daysUntilDueString = 'today';
  } else if (daysUntilDue === 1) {
    daysUntilDueString = 'in 1 day';
  } else {
    daysUntilDueString = `in ${daysUntilDue} days`;
  }

  return `Next assignment due ${daysUntilDueString}`;
};

export const getMotivationalMessage = (assignments) => {
  if (assignments.length === 0) {
    return '';
  }

  let allNotStarted = true;
  let allCompleted = true;
  let allMissed = true;

  // Sets up flags so we only have to iterate through the assignments once
  for (const assignment of assignments) {
    if (assignment.status !== ASSIGNMENT_STATUS.NOT_STARTED) {
      allNotStarted = false;
    }
    if (assignment.status !== ASSIGNMENT_STATUS.COMPLETED) {
      allCompleted = false;
    }
    if (assignment.status !== ASSIGNMENT_STATUS.MISSED) {
      allMissed = false;
    }

    // If all flags are false, no need to keep going
    if (!allNotStarted && !allCompleted && !allMissed) {
      break;
    }
  }

  if (allNotStarted) {
    return WEEKLY_PROGRESS_MESSAGES.ALL_NOT_STARTED;
  }

  if (allCompleted) {
    return WEEKLY_PROGRESS_MESSAGES.ALL_COMPLETED;
  }

  if (!allMissed) {
    return WEEKLY_PROGRESS_MESSAGES.PARTIAL_PROGRESS;
  }

  return '';
};
